exports = module.exports = require("../docs/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-list-date{display:flex;justify-content:center;align-items:center;margin-top:30px}.v-list-date .v-list-date-label{font-size:12px;color:#999}.v-list-date .v-list-date-text{font-size:12px;color:#666}.v-list-item{padding:10px;margin:0 5px}.v-list{width:300px;margin:0 auto}.v-list-1[data-v-6fe191b6]{background-color:#333}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!../dist/vue-rollup-component-template.css
// module id = 17
// module chunks = 0